import { z } from "zod";

/**
 * Names are shown to other league members, so we enforce a sensible shape:
 *  - Unicode letters (so José, Müller, 王 all work)
 *  - Spaces, hyphens, apostrophes, periods (so O'Brien, Anne-Marie, Jr.,
 *    "van der Berg" all work)
 *  - 2–50 chars after trimming
 *  - No digits or other symbols
 *
 * Existing profiles are NOT retroactively validated — these rules only apply
 * to new writes (signup, profile edits).
 */
const NAME_PATTERN = /^[\p{L}][\p{L}\s'.\-]*$/u;
const NAME_MIN = 2;
const NAME_MAX = 50;

export function isValidName(raw: string): boolean {
  const v = raw.trim();
  if (v.length < NAME_MIN || v.length > NAME_MAX) return false;
  return NAME_PATTERN.test(v);
}

export const nameSchema = (label: string) =>
  z
    .string()
    .trim()
    .min(NAME_MIN, { message: `${label} must be at least ${NAME_MIN} characters.` })
    .max(NAME_MAX, { message: `${label} must be at most ${NAME_MAX} characters.` })
    .regex(NAME_PATTERN, {
      message: `${label} can only contain letters, spaces, hyphens, apostrophes, and periods.`,
    });

export const NAME_HELPER_TEXT =
  "Letters, spaces, hyphens, apostrophes, and periods. 2–50 characters.";
